import React from 'react';
import styled from 'styled-components';
import mediaQ from '../theme/responsive';

const Footer = ({ footerData }) => {
    return (
        <FooterWrapper>
            <FooterContainer>
                <FooterRowTop>
                    <FooterSocialIcons>
                        {footerData.socialLinks &&
                            footerData.socialLinks.map(entry => {
                                return (
                                    <FooterSocialLink key={entry.url}>
                                        <a href={entry.url} target="_blank" rel="noopener noreferrer">
                                            <img style={{ width: '100%' }} src={entry.imageUrl} alt="Facebook icon" />
                                        </a>
                                    </FooterSocialLink>
                                );
                            })}
                    </FooterSocialIcons>
                </FooterRowTop>
                <FooterRowBottom>
                    <CopyrightText>
                        © {new Date().getFullYear()} {footerData.companyName}
                    </CopyrightText>
                    <FooterMetaLinksWrapper>
                        {footerData.metaLinks &&
                            footerData.metaLinks.map(entry => {
                                if (entry.type === 'URL') {
                                    return (
                                        <StyledLink key={entry.url} href={entry.url} target="_blank" rel="noopener noreferrer">
                                            <p>{entry.title}</p>
                                        </StyledLink>
                                    );
                                } else {
                                    return (
                                        <StyledLink key={entry.url} className="ucShow_ clickable">
                                            <p>{entry.title}</p>
                                        </StyledLink>
                                    );
                                }
                            })}
                    </FooterMetaLinksWrapper>
                </FooterRowBottom>
            </FooterContainer>
        </FooterWrapper>
    );
};

const Wrapper = styled.div`
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
`;

const FooterWrapper = styled.div`
    border-top: 1px solid rgba(0, 0, 0, 0.16);
    padding: 5rem 0 6.25rem;
    width: 100%;
    margin-bottom: 140px;
    margin-top: 60px;
`;

const FooterContainer = styled.div`
    max-width: 1400px;
    margin: 0 auto;
    padding-left: 50px;
    padding-right: 50px;
    ${mediaQ.tablet`
        flex-direction: column;
    `}
`;

const FooterRowTop = styled.div`
    display: flex;
    justify-content: flex-end;
    ${mediaQ.tablet`
        justify-content: flex-start;
    `};
`;

const FooterRowBottom = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 2.5rem;
    flex-wrap: wrap;
    ${mediaQ.tablet`
        justify-content: flex-start;
        flex-direction: column-reverse;
    `}
    gap: 1.5rem;
`;

const FooterMetaLinksWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 1.5rem;
    ${mediaQ.tablet`
        flex-direction: column;
        margin-bottom: 1.5rem;
    `};
`;

const FooterLogoContent = styled.div`
    display: flex;
    justify-content: flex-start;
`;

const FooterLogo = styled.div`
    padding-left: 60px;
`;
const FooterSocialIcons = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
`;
const FooterSocialLink = styled.div`
    width: 2.5rem;
    height: 2.5rem;
    padding: 0.5rem;
    a {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
    }
    &:hover {
        background-color: rgba(0, 0, 0, 0.08);
        cursor: pointer;
    }
`;

const FooterRegion = styled.div`
    font-size: 0.75rem;
    font-weight: lighter;
    line-height: 1;
    margin-left: 0.3125rem;
    color: #999;
    text-transform: uppercase;
`;

const StyledLink = styled.a`
    color: black;
    text-decoration: inherit;
    padding-bottom: 0.25rem;
    &:hover {
        border-bottom: 1px solid #000;
        cursor: pointer;
    }
    &:active {
        background-color: #3d3d3d;
        color: #fff;
    }
    font-size: 0.875rem;
    font-family: 'GROTESK Medium', sans-serif;
`;
const CopyrightText = styled.span`
    font-size: 0.875rem;
    color: #5c5c5c;
`;

export default Footer;
